import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PlusCircle, Eye } from "react-feather";
import DataTable from "../../../../components/common/DataTable";
import { useListStockOutsQuery } from "../../stockApi";
import { useCanCreateStockOut } from "../../useStockPermissions";
import { useBranchFilter } from "../../../branchFilter/useBranchFilter";
import { paths } from "../../../../routes/paths";

const ISSUED_TO_OPTIONS = [
  { value: "", label: "All" },
  { value: "EMPLOYEE", label: "Employee" },
  { value: "CUSTOMER", label: "Customer" },
];

const StockOutList = () => {
  const canCreate = useCanCreateStockOut();
  const navigate = useNavigate();
  const { selectedBranchId } = useBranchFilter();
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [issuedToType, setIssuedToType] = useState("");
  const [includeDeleted, setIncludeDeleted] = useState(false);

  useEffect(() => {
    const handle = setTimeout(() => setSearch(searchInput.trim()), 400);
    return () => clearTimeout(handle);
  }, [searchInput]);

  const { data, isLoading } = useListStockOutsQuery({
    branchId: selectedBranchId ?? undefined,
    issuedToType: issuedToType || undefined,
    search: search || undefined,
    includeDeleted,
    pageSize: 100,
  });

  const columns = [
    {
      title: "Stock-Out No",
      dataIndex: "stockOutNo",
      render: (value, record) => <Link to={paths.stockOutDetail(record.recordGuid)}>{value}</Link>,
    },
    { title: "Branch", dataIndex: "branchCode" },
    { title: "Issued To", dataIndex: "issuedToType", render: (v, r) => `${v === "EMPLOYEE" ? "Employee" : "Customer"}: ${v === "EMPLOYEE" ? r.issuedToEmployeeName || "-" : r.issuedToCustomerName || "-"}` },
    { title: "Purpose", dataIndex: "issuedForPurpose", render: (v) => v || "-" },
    { title: "Date", dataIndex: "stockOutDate", render: (v) => (v ? new Date(v).toLocaleDateString() : "-") },
    { title: "Total Amount", dataIndex: "totalAmount", render: (v) => Number(v || 0).toFixed(2) },
    {
      title: "Status",
      dataIndex: "isDeleted",
      render: (v) => (v ? <span className="badge badge-linedanger">Deleted</span> : <span className="badge badge-linesuccess">Issued</span>),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <button type="button" className="btn btn-link p-2" title="View" onClick={() => navigate(paths.stockOutDetail(record.recordGuid))}>
          <Eye size={16} />
        </button>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Stock-Out</h4>
              <h6>Stock issued to an employee or a customer</h6>
            </div>
          </div>
          {canCreate && (
            <div className="page-btn">
              <button type="button" className="btn btn-added" onClick={() => navigate(paths.stockOutNew)}>
                <PlusCircle className="me-2" size={16} />
                New Stock-Out
              </button>
            </div>
          )}
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top flex-wrap gap-2">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search Stock-Out No"
                    className="form-control form-control-sm formsearch"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                </div>
              </div>
              <div className="d-flex gap-2 flex-wrap">
                <select className="form-control" value={issuedToType} onChange={(e) => setIssuedToType(e.target.value)}>
                  {ISSUED_TO_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="stockout-include-deleted"
                  checked={includeDeleted}
                  onChange={(e) => setIncludeDeleted(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="stockout-include-deleted">Show deleted</label>
              </div>
            </div>
            <div className="table-responsive">
              <DataTable columns={columns} dataSource={data?.items || []} rowKey="recordGuid" loading={isLoading} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockOutList;
